// Avatars
import { dynamicImage } from "../../../Service/DynamicImage";

//Sizes
export const SIZE_IMAGES = [
  {
    className: "img-90",
    src: dynamicImage("avtar/4.jpg"),
  },
  {
    className: "img-80",
    src: dynamicImage("avtar/7.jpg"),
  },
  {
    className: "img-70",
    src: dynamicImage("avtar/11.jpg"),
  },
];

export const SIZE_DATA = [{ code: ".img- * (70/80/90/100)", text: "You can change the size of avatar using " }, { text: " class" }];

// StatusIndicator
export const STATUS_DATA = [{ code: " .status-* (online/offline/dnd) ", text: "Using " }, { text: " class you can set the status of avatar." }];

export const STATUS_INDICATOR = [
  {
    className: "img-90",
    src: dynamicImage("avtar/16.jpg"),
  },
  {
    className: "img-80",
    src: dynamicImage("avtar/7.jpg"),
  },
  {
    className: "img-70",
    src: dynamicImage("avtar/3.jpg"),
  },
];

// Shaps
export const SHAPS_DATA = [{ code: " .b-r-* (8/30/35/25)", text: "Using the" }, { text: " class you can set the shapes of avatar." }];

export const SHAP = [
  {
    className: "img-90",
    src: dynamicImage("avtar/16.jpg"),
  },
  {
    className: "img-80",
    src: dynamicImage("avtar/3.jpg"),
  },
  {
    className: "img-70",
    src: dynamicImage("avtar/11.jpg"),
  },
];

// Ratio
export const RATIO_DATA = [{ code: ".ratio", text: "Give the shape to avatar using " }, { code: " img-* (50/70/80/90/100) ", text: " and " }, { text: " class." }];

export const RATIO = [
  {
    className: "img-90",
    src: dynamicImage("avtar/4.jpg"),
  },
  {
    className: "img-80",
    src: dynamicImage("user/1.jpg"),
  },
  {
    className: "img-70",
    src: dynamicImage("avtar/16.jpg"),
  },
  {
    className: "img-50",
    src: dynamicImage("avtar/7.jpg"),
  },
];

// Grouping
export const GROUPING_DATA = [
  { code: ".img-* (40/50/60/80/100) ", text: "You can set the group of avatars like " },
  { code: ".b-r-* (8/30/35).", text: "and " },
];

export const GROUPING_FIRST = [
    {
      className: "img-80 b-r-30",
      src: dynamicImage("avtar/16.jpg"),
    },
    {
      className: "img-50 b-r-35",
      src: dynamicImage("avtar/3.jpg"),
    },
  ];

export const GROUPING_SECOND = [
  {
    className1: "b-r-8 img-80",
    src: dynamicImage("user/1.jpg"),
  },
  {
    className2: "img-60 rounded-circle",
    src: dynamicImage("avtar/16.jpg"),
  },
];

export const GROUPING_THIRD = [
    {
      src: dynamicImage("user/5.jpg"),
    },
    {
      src: dynamicImage("user/1.jpg"),
    },
  ];
